"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.estimationTargetSelectorOptions = exports.estimationTargetMyHomeSelectorOptions = void 0;
var _types = require("../types");
/**
 * Данные для фильтра "Тип оцениваемого объекта"
 * */

const estimationTargetSelectorOptions = exports.estimationTargetSelectorOptions = [{
  value: _types.EEstimationTargets.flat,
  selectedLabel: 'Квартира',
  label: 'Квартира'
}, {
  value: _types.EEstimationTargets.house,
  selectedLabel: 'Дом',
  label: 'Дом'
}, {
  value: _types.EEstimationTargets.land,
  selectedLabel: 'Участок',
  label: 'Участок'
}, {
  value: _types.EEstimationTargets.newbuilding,
  selectedLabel: 'ЖК',
  label: 'ЖК'
}];
const estimationTargetMyHomeSelectorOptions = exports.estimationTargetMyHomeSelectorOptions = [{
  value: _types.EEstimationTargets.flat,
  selectedLabel: 'Квартира',
  label: 'Квартира'
}, {
  value: _types.EEstimationTargets.house,
  selectedLabel: 'Дом',
  label: 'Дом'
}, {
  value: _types.EEstimationTargets.land,
  selectedLabel: 'Участок',
  label: 'Участок'
}];